import { PartnerAssociatedAccounts } from '@anytag/shared-organisms';
import { usePartnerDetailsContext } from './partner-details-context';

export const PartnerBusiness = () => {
  const { partner } = usePartnerDetailsContext();

  return <PartnerAssociatedAccounts partnerId={partner.id} />;
};
